export enum ProcessingStatus {
    ToDo = 'ToDo',
    WaitingReview = 'WaitingReview',
    Qualifiable = 'Qualifiable',
    PendingOfferConfirmation = 'PendingOfferConfirmation',
    PendingAssignment = 'PendingAssignment',
    Assigned = 'Assigned',
    Done = 'Done'
}